import { Baby, Heart, Users, Mountain, Sparkles, Check, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { FAZZENDA_AUDIENCES } from "@/data/resorts";
import { scrollToId } from "@/lib/scroll";

const ICONS = { Baby, Heart, Users, Mountain, Sparkles };

export default function ForWhom({ items = FAZZENDA_AUDIENCES, target = "cotacao-resort" }) {
    return (
        <section id="para-quem" className="bg-forest-deep py-24 sm:py-32" data-testid="for-whom-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">Para Quem É o Resort</p>
                    <h2 className="mt-3 max-w-2xl font-serif text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Um destino, três jeitos de viver
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
                    {items.map((a, i) => {
                        const Icon = ICONS[a.icon] || Users;
                        return (
                            <Reveal key={a.id} delay={i * 0.12}>
                                <article
                                    className="group flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06] backdrop-blur-md transition-colors duration-300 hover:border-gold/40"
                                    data-testid={`audience-card-${a.id}`}
                                >
                                    <div className="relative h-52 overflow-hidden">
                                        <img src={a.img} alt={a.imgAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                                        <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 to-transparent" />
                                        <span className="absolute bottom-4 left-4 flex h-11 w-11 items-center justify-center rounded-full bg-gold text-forest-deep">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                    </div>
                                    <div className="flex flex-1 flex-col p-7">
                                        <h3 className="font-serif text-2xl font-semibold text-white">{a.title}</h3>
                                        <p className="mt-2 text-sm leading-relaxed text-stone-300">{a.text}</p>
                                        <ul className="mt-5 flex-1 space-y-2.5">
                                            {a.bullets.map((b) => (
                                                <li key={b} className="flex items-start gap-2.5 text-sm text-stone-200">
                                                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                                                    {b}
                                                </li>
                                            ))}
                                        </ul>
                                        <button
                                            type="button"
                                            data-testid={`audience-cta-${a.id}`}
                                            onClick={() => scrollToId(target)}
                                            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold transition-colors hover:text-white"
                                        >
                                            Cotar essa experiência
                                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                                        </button>
                                    </div>
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
